import { SubscriptionStatus } from '@fsp/types';

export const getSubscriptionStatusColor = (
  status: SubscriptionStatus
): 'success' | 'warning' | 'error' | 'default' | 'info' => {
  switch (status) {
    case SubscriptionStatus.ACTIVE:
      return 'success';
    case SubscriptionStatus.TRIALING:
      return 'info';
    case SubscriptionStatus.PAST_DUE:
      return 'warning';
    case SubscriptionStatus.CANCELED:
    case SubscriptionStatus.INACTIVE:
      return 'error';
    default:
      return 'default';
  }
};
